import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Theme, THEMES } from './themes';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private colorSource = new BehaviorSubject<Theme>(THEMES[0]); // Default color
  currentColor$ = this.colorSource.asObservable();

  setColor(theme: Theme) {
    this.colorSource.next(theme);
  }
}
